<template>
<div class="findpassword" id="">  
  <XR-head titleText="邮箱重置支付密码" :rightShow="false" ref="head"></XR-head>
  <div class="login-form" v-if="!loaded">
    <mu-row gutter>
      <mu-col width="100" tablet="100" desktop="33">
        <mu-text-field label="邮箱" icon=":fa fa-envelope-o" labelFloat fullWidth :disabled="true" v-model="resetInfo.email" />
      </mu-col>
    </mu-row>
    <mu-row gutter>
      <mu-col width="70" tablet="75" desktop="33">
        <mu-text-field label="验证码" helpText="点击右侧按钮获取" v-model="resetInfo.code" icon=":fa fa-key" labelFloat fullWidth />
      </mu-col>
      <mu-col width="30" tablet="25" desktop="33">      
        <mu-raised-button :label="smsBtnText" class="sms-button" @click="getSmsCode()" secondary/>   
      </mu-col>
    </mu-row>
    <mu-row gutter>
      <mu-col width="100" tablet="100" desktop="33">
        <mu-text-field label="新密码" type="password" icon=":fa fa-lock" labelFloat fullWidth v-model="resetInfo.password" />
      </mu-col>
    </mu-row>
    <mu-row gutter>
      <mu-col width="100" tablet="100" desktop="33">
        <mu-text-field label="确认密码" type="password" icon=":fa fa-lock" labelFloat fullWidth v-model="resetInfo.confrimPassword" />
      </mu-col>
    </mu-row>
    <mu-row gutter>
      <mu-col width="100" tablet="50" desktop="33" class="login-div">
        <mu-raised-button label="下一步" class="demo-raised-button" primary fullWidth @click="submit()" />
      </mu-col>
    </mu-row>
  </div>
  <XR-toast @onClose="goBack" ref="XRtoast"></XR-toast>
</div>
</template>
<script>
import md5 from 'js-md5'
export default {
  data () {
    return {
      loaded:true,
      resetInfo:{
        email:'',
        code:'',
        password:'',
        confrimPassword:''
      },
      smsBtnText : '验证码'
    }
  },
  mounted(){
    this.$refs.XRtoast.load()
    this.getMemberInfo()
  },
  methods: {
    getMemberInfo(){           
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.loaded =false          
          ths.$refs.XRtoast.hide()

          if(!res.Data.IsTestEmail){
            ths.$router.goBack()
          }
          ths.resetInfo.email=res.Data.email
        }
      });      
    },
    submit: function () {
      var ths = this;   
      if(!ths.resetInfo.code){
          ths.$refs.XRtoast.failed("请输入验证码", true)
        return
      }
      if(!ths.resetInfo.password){
          ths.$refs.XRtoast.failed("请输入新支付密码", true)
        return
      }
      if(!ths.resetInfo.confrimPassword){
          ths.$refs.XRtoast.failed("请输入确认支付密码", true)
        return
      }
      if(ths.resetInfo.password != ths.resetInfo.confrimPassword){
          ths.$refs.XRtoast.failed("二次输入的密码不一样", true)
        return
      }

      ths.$post(
        "/Shop/UserServer/ModifyPayPasswordByEmail",
        JSON.stringify(this.resetInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.resetInfo.code = ''
          ths.resetInfo.password = ''
          ths.resetInfo.confrimPassword = ''
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{ 
          ths.$refs.XRtoast.success(res.Msg, true)
        }
      });
    },
    getSmsCode: function(){
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/ModifyPayPasswordSendCodeByEmail"
      ).then(function(res) {
        ths.$refs.XRtoast.hide()
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{          
          ths.smsBtnText = res.Data * 60;
          var interval = setInterval(function(){
            if(ths.smsBtnText >0){
              ths.smsBtnText--
            }else{
              ths.smsBtnText = '获取短信'
              clearInterval(interval)
            }
          }, 1000)  
        }
      });
    },
    goBack(){
      this.$router.go(-2)
    }
  }
}

</script>
<style>
.findpassword{
  background: white;
}
.findpassword .login-form {
  padding: 10px 20px 20px 10px;
}
.findpassword .login-div {
  padding: 40px 0px 0 20px;
}
.findpassword .demo-raised-button {
  height: 50px;
}
.findpassword .div2 {
  padding: 20px 0 0 0;
}
.findpassword .demo-flat-button.right {
  float: right;
}
.findpassword .div3 {
  text-align: center;
  position: absolute;
  bottom: 40px;
  left: 0;
}
.findpassword .findpassword .notice{
  font-size: 12px;
}
.findpassword .sms-button{
  margin-top: 28px;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/paypasswordResetByEmail.vue